import React from 'react';
import PropTypes from 'prop-types';

import ButtonBar from 'components/ButtonBar';
import Nav from 'components/Nav';

const Header = ({ pathname }) => (
  <div className="header">
    {pathname.length > 7 && <Nav pathname={pathname} />}
    {pathname.length < 7 && <ButtonBar />}
  </div>
);

export default Header;

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
};
